import React from "react";
import { H4 } from "@ui/Text";
import { styled } from "@linaria/react";

export default function Section({
  title,
  className,
  children,
}: React.PropsWithChildren<{
  title: string;
  className?: string;
}>) {
  return (
    <section className={className}>
      <H4>{title}</H4>
      <Content>{children}</Content>
    </section>
  );
}

const Content = styled.section`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
